import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, fromEvent, merge, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { fuseAnimations, FuseUtils } from '@fuse/utils';
import { ServiceService } from '../service.service';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute , Router} from '@angular/router';
import { TenantService } from '../../tenant/tenant.service';
import { locale as english } from '../../../../main/home/i18n/en';
import { locale as turkish } from '../../../../main/home/i18n/tr';
import { locale as arabic } from '../../../../main/home/i18n/ar';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'app/shared/services/loader-service';
@Component({
    selector: 'app-service',
    templateUrl: './service-list.component.html',
    styleUrls: ['./service-list.component.scss'],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None
})
export class ServiceComponent implements OnInit {
    dataSource: any;
    displayedColumns = ["name", "discription", "tenant", "actions"];
    pageIndex : number = 1 ;
    pageSize :number = 10;
    pageSizeOptions  =[5, 10, 25, 100];
    length="length";
    search : string = null;

    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
    @ViewChild(MatPaginator, { static: true })
    paginator: MatPaginator;

    @ViewChild(MatSort, { static: true })
    sort: MatSort;

    @ViewChild('filter', { static: true })
    filter: ElementRef;

    // Private
    private _unsubscribeAll: Subject<any>;
    TenantId: string;
    Tenant: any;


    constructor(
        private serviceService: ServiceService,
        private _matSnackBar: MatSnackBar,
        private _matDialog: MatDialog,
        private route: ActivatedRoute,
        private tenantService: TenantService,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private translate: TranslateService,
        public loaderService : LoaderService,
        private router : Router
        
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this._fuseTranslationLoaderService.loadTranslations(english, turkish, arabic);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        //this.dataSource = this.getServices();

         /*
        fromEvent(this.filter.nativeElement, 'keyup')
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(150),
                distinctUntilChanged()
            )
            .subscribe(() => {
                if (!this.dataSource) {
                    return;
                }

                this.dataSource.filter = this.filter.nativeElement.value;
            });

           */
        this.route.paramMap.subscribe(params => {
            if (params.get('tenantId')) {
                this.TenantId = params.get('tenantId');
                this.serviceService.getServicByTenant(this.TenantId , this.serviceService.currentPage ,this.serviceService.pageSize).then(res => {
                    if (res) {
                        this.dataSource = res.data;
                        this.pageIndex = res.pageNumber;
                        this.pageSize = res.pageSize;
                        this.length = res.totalItems;
                    }
                });
                this.tenantService.getTenantById(this.TenantId).then(res => {
                    if (res) {
                        this.Tenant = res;
                    }
                });
            }
            else {
                this.getServices();
            }
        });
    }
    deleteService(id) {
        this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
            disableClose: false
        });


        this.confirmDialogRef.componentInstance.confirmMessage = this.translate.instant('CONFIRM_MSG.wantToDelete')




        this.confirmDialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.serviceService.deleteService(id).then(() => {
                    // Show the success message
                    this._matSnackBar.open(this.translate.instant('CONFIRM_MSG.serviceDeleted'), this.translate.instant('CONFIRM_MSG.ok'), {
                        verticalPosition: 'top',
                        duration: 2000
                    });
                    this.ngOnInit();
                })

            }
        })

    }

    getServices(){
        this.serviceService.getServices(this.serviceService.currentPage ,this.serviceService.pageSize).then(res => {
            if (res) {
                    this.dataSource = res.data;
                    this.pageIndex = res.pageNumber;
                    this.pageSize = res.pageSize;
                    this.length = res.totalItems;
            }
        });
    }

    applyFilter(filterValue: string) {
        if(filterValue){
            this.serviceService.getServicesByFilter(this.pageIndex ,this.pageSize, filterValue).then(res => {
                if (res) {
                    this.dataSource = res.data;
                    this.pageIndex = res.pageNumber;
                    this.pageSize = res.pageSize;
                    this.length = res.totalItems;
                }
            })
        }
        else
        {
            this.ngOnInit();
        }
        
    }

    getTenantBypagenation(pagenation : any){
        if(pagenation){
            if(this.TenantId) {
                this.serviceService.getServicByTenant(this.TenantId , pagenation.pageIndex+1 ,pagenation.pageSize).then(res => {
                    if (res) {
                        this.dataSource = res.data;
                        this.pageIndex = res.pageNumber;
                        this.pageSize = res.pageSize;
                        this.length = res.totalItems;
                    }
                });
                this.tenantService.getTenantById(this.TenantId).then(res => {
                    if (res) {
                        this.Tenant = res;
                    }
                });
            }
            else{
                this.serviceService.getServices(pagenation.pageIndex+1 ,pagenation.pageSize).then(res => {
                    if (res) {
                        this.dataSource = res.data;
                        this.pageIndex = res.pageNumber;
                        this.pageSize = res.pageSize;
                        this.length = res.totalItems;
                    }
                })
            }
           
        }
    }

    edit(serviceId){
        this.serviceService.currentPage = this.pageIndex;
        this.serviceService.pageSize = this.pageSize;
        this.router.navigate(['/service/tenant/'+ this.TenantId + '/edit/' + serviceId] );
    }
}


export class FilesDataSource extends DataSource<any>
{
    private _filterChange = new BehaviorSubject('');
    private _filteredDataChange = new BehaviorSubject('');

    /**
     * Constructor
     *
     * @param {serviceService} serviceService
     * @param {MatPaginator} _matPaginator
     * @param {MatSort} _matSort
     */
    constructor(
        private serviceService: ServiceService,
        private _matPaginator: MatPaginator,
        private _matSort: MatSort
    ) {
        super();

        this.filteredData = this.serviceService.services;
    }

    /**
     * Connect function called by the table to retrieve one stream containing the data to render.
     *
     * @returns {Observable<any[]>}
     */
    connect(): Observable<any[]> {
        const displayDataChanges = [
            this.serviceService.onServiceChanged,
            this._matPaginator.page,
            this._filterChange,
            this._matSort.sortChange
        ];

        return merge(...displayDataChanges)
            .pipe(
                map(() => {
                    let data = this.serviceService.services.slice();

                    data = this.filterData(data);

                    this.filteredData = [...data];

                    data = this.sortData(data);

                    // Grab the page's slice of data.
                    const startIndex = this._matPaginator.pageIndex * this._matPaginator.pageSize;
                    return data.splice(startIndex, this._matPaginator.pageSize);
                }
                ));
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    // Filtered data
    get filteredData(): any {
        return this._filteredDataChange.value;
    }

    set filteredData(value: any) {
        this._filteredDataChange.next(value);
    }

    // Filter
    get filter(): string {
        return this._filterChange.value;
    }

    set filter(filter: string) {
        this._filterChange.next(filter);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Filter data
     *
     * @param data
     * @returns {any}
     */
    filterData(data): any {
        if (!this.filter) {
            return data;
        }
        return FuseUtils.filterArrayByString(data, this.filter);
    }

    /**
     * Sort data
     *
     * @param data
     * @returns {any[]}
     */
    sortData(data): any[] {
        if (!this._matSort.active || this._matSort.direction === '') {
            return data;
        }

        return data.sort((a, b) => {
            let propertyA: number | string = '';
            let propertyB: number | string = '';

            switch (this._matSort.active) {
                case 'id':
                    [propertyA, propertyB] = [a.id, b.id];
                    break;
                case 'name':
                    [propertyA, propertyB] = [a.name, b.name];
                    break;

            }

            const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
            const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

            return (valueA < valueB ? -1 : 1) * (this._matSort.direction === 'asc' ? 1 : -1);
        });
    }

    /**
     * Disconnect
     */
    disconnect(): void {
    }
}
